import type { HttpErrorResponse } from '@angular/common/http';

import type { ResponseStatus, ViewboxInterviewEvent } from '@recruitee/interview-events-types';
import { createActions, ngrxEvent } from '@recruitee/ngrx';

import type { ScheduleFailedPayload, SchedulerAvailability } from './types';

const namespace = 'viewboxInterviewSchedule';

export const ViewboxInterviewScheduleActions = createActions(namespace, {
  loadItem: ngrxEvent<{
    scheduleToken: string;
    requestLinkToken: string;
    candidateTimezone: string;
    reschedule: boolean;
  }>(),
  loadItemSuccess: ngrxEvent<SchedulerAvailability>(),
  loadItemFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
  confirmSchedule: ngrxEvent<{
    scheduleToken: string;
    requestLinkToken: string;
    reschedule: boolean;
    interviewEvent: {
      startsAt: string;
      candidateTimezone: string;
      candidateEmail?: string;
      rescheduleReason?: string;
    };
  }>(),
  confirmScheduleSuccess: ngrxEvent<SchedulerAvailability>(),
  confirmScheduleFailed: ngrxEvent<ScheduleFailedPayload>(),
  rsvp: ngrxEvent<{
    eventToken: string;
    rsvpToken: string;
    responseStatus: ResponseStatus;
  }>(),
  rsvpSuccess: ngrxEvent<ViewboxInterviewEvent>(),
  rsvpFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
});
